import { css } from '@emotion/css';
import { colors, shadows, spacing } from '@prezzee/tokens';
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
}

const style = css`
  display: flex;
  flex-direction: column;
  box-shadow: ${shadows.md};
  border-radius: ${spacing.spacing01};
  padding: ${spacing.spacing08};
  background-color: ${colors.white};
  height: 100%;

  img {
    height: 28px;
    width: 28px;
    margin-bottom: 12px;
  }

  h3 {
    font-size: 24px;
    color: ${colors.gray800};
    font-weight: 600;
    margin-bottom: 12px;
  }
`;

const Card = ({ children }: CardProps) => {
  return <div className={style}>{children}</div>;
};

export default Card;
